import React from 'react';
import { SxProps, Theme } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';
import CustomTextField from '../forms/theme-elements/CustomTextField';

interface JsonInputProps {
  id?: string;
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  error?: string | null;
  rows?: number;
  disabled?: boolean;
  placeholder?: string;
  label?: string;
  helperText?: string;
  minRows?: number;
  sx?: SxProps<Theme>;
}

export const JsonInput: React.FC<JsonInputProps> = ({
  id,
  value,
  onChange,
  onBlur,
  error,
  rows = 6,
  disabled = false,
  placeholder = '{\n  "key": "value"\n}',
  label,
  helperText,
  minRows,
  sx,
}) => {
  const theme = useTheme();

  return (
    <CustomTextField
      id={id}
      multiline
      rows={minRows === undefined ? rows : undefined}
      minRows={minRows}
      fullWidth
      value={value}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
      onBlur={onBlur}
      disabled={disabled}
      error={Boolean(error)}
      placeholder={placeholder}
      label={label}
      helperText={error || helperText}
      sx={{
        '& .MuiInputBase-input': {
          fontFamily: 'monospace',
          fontSize: '13px',
          lineHeight: 1.5,
        },
        ...(error && {
          '& fieldset': {
            borderColor: `${theme.palette.error.main} !important`,
          },
        }),
        ...sx,
      }}
    />
  );
};
